import { render, staticRenderFns } from "./InstitutionLmsConfiguration.vue?vue&type=template&id=1b647116&scoped=true&"
import script from "./InstitutionLmsConfiguration.vue?vue&type=script&lang=js&"
export * from "./InstitutionLmsConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./InstitutionLmsConfiguration.vue?vue&type=style&index=0&id=1b647116&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b647116",
  null
  
)

export default component.exports